import { map } from 'ramda';
import { ASSIGN_PAYMENTS, REMOVE_PAYMENT } from './constants';
import { paymentFactory } from './helpers';

export const preparePayments = map(paymentFactory);

export const assignPayments = payments => ({
  type: ASSIGN_PAYMENTS,
  payload: preparePayments(payments),
});

export const removePayment = id => ({
  type: REMOVE_PAYMENT,
  payload: id,
});
